import { render, staticRenderFns } from "./NewAffiliateDialog.vue?vue&type=template&id=1c5c6164&"
import script from "./NewAffiliateDialog.vue?vue&type=script&lang=js&"
export * from "./NewAffiliateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewAffiliateDialog.vue"
export default component.exports